var _defs, _rect, _g, _g2, _path, _g3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroidStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 215.448,
    height: 64,
    viewBox: "0 0 215.448 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#030404;}.b{fill:#969695;}.c,.d{fill:#fff;}.c{stroke:#fff;stroke-miterlimit:10;stroke-width:0.2px;}.e{fill:#40bff2;}.f{fill:url(#a);}.g{fill:url(#b);}.h{fill:url(#c);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.808,
    y1: 0.5,
    x2: -1.573,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gold"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.075,
    stopColor: "#fece00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#fca704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#fa8e07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa8608"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.862,
    y1: 0.178,
    x2: -0.501,
    y2: 1.948,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e82b36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b4005a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -0.507,
    y1: -0.956,
    x2: 0.606,
    y2: 0.489,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f8e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#4ea157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#67b054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70b653"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 215.274,
    height: 64,
    rx: 5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.164)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M217.469,11.277a6.71,6.71,0,0,1,6.7,6.7V65.857a6.71,6.71,0,0,1-6.7,6.7H17.98a6.71,6.71,0,0,1-6.7-6.7V17.98a6.71,6.71,0,0,1,6.7-6.7H217.469m0-1.277H17.98A8,8,0,0,0,10,17.98V65.857a8,8,0,0,0,7.98,7.98H217.469a8,8,0,0,0,7.98-7.98V17.98a8,8,0,0,0-7.98-7.98Z",
    transform: "translate(-10 -10)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.994 11.122)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M61.033,22.255a4.323,4.323,0,0,1-1.189,3.2,4.641,4.641,0,0,1-3.517,1.417,4.932,4.932,0,0,1-4.974-5,4.932,4.932,0,0,1,4.974-5,4.957,4.957,0,0,1,1.966.4,3.939,3.939,0,0,1,1.5,1.071l-.841.841a3.239,3.239,0,0,0-2.622-1.135,3.7,3.7,0,0,0-3.718,3.824A3.766,3.766,0,0,0,59,24.624a3.02,3.02,0,0,0,.8-1.941H56.326V21.534h4.641A4.081,4.081,0,0,1,61.033,22.255Z",
    transform: "translate(-51.352 -16.866)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M64.115,18.176H59.754v3.037h3.932v1.149H59.754V25.4h4.362v1.176h-5.59V17h5.59Z",
    transform: "translate(-47.078 -16.786)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M66.737,26.575H65.505v-8.4H62.832V17h6.58v1.176H66.737Z",
    transform: "translate(-44.511 -16.786)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M69.938,26.575V17h1.229v9.575Z",
    transform: "translate(-40.276 -16.786)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M75.586,26.575h-1.23v-8.4H71.681V17h6.58v1.176H75.586Z",
    transform: "translate(-39.238 -16.786)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M86.757,25.418a4.972,4.972,0,0,1-7.02,0,4.9,4.9,0,0,1-1.411-3.551,4.9,4.9,0,0,1,1.411-3.551,4.957,4.957,0,0,1,7.014.006,5.158,5.158,0,0,1,.006,7.1Zm-6.112-.8a3.683,3.683,0,0,0,5.2,0,3.748,3.748,0,0,0,1.064-2.748,3.748,3.748,0,0,0-1.064-2.748,3.683,3.683,0,0,0-5.2,0,3.753,3.753,0,0,0-1.063,2.748A3.753,3.753,0,0,0,80.645,24.616Z",
    transform: "translate(-35.278 -16.866)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M85.575,26.575V17h1.5l4.654,7.448h.053L91.727,22.6V17h1.23v9.575H91.675l-4.869-7.81h-.053l.053,1.846v5.964Z",
    transform: "translate(-30.958 -16.786)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M94.282,34.556a6.787,6.787,0,1,0,6.813,6.787A6.69,6.69,0,0,0,94.282,34.556Zm0,10.9a4.124,4.124,0,1,1,3.83-4.113A3.927,3.927,0,0,1,94.282,45.456Zm-14.863-10.9a6.787,6.787,0,1,0,6.813,6.787A6.69,6.69,0,0,0,79.419,34.556Zm0,10.9a4.124,4.124,0,1,1,3.83-4.113A3.927,3.927,0,0,1,79.419,45.456ZM61.738,36.638v2.879h6.89a6.009,6.009,0,0,1-1.567,3.624,7.055,7.055,0,0,1-5.322,2.108,7.662,7.662,0,0,1,0-15.322,7.341,7.341,0,0,1,5.193,2.057l2.032-2.032a10.047,10.047,0,0,0-7.225-2.906,10.543,10.543,0,1,0,0,21.084,9.633,9.633,0,0,0,7.352-2.957,9.515,9.515,0,0,0,2.494-6.736,9.3,9.3,0,0,0-.155-1.8Zm72.308,2.236a6.308,6.308,0,0,0-5.811-4.319,6.449,6.449,0,0,0-6.4,6.787,6.642,6.642,0,0,0,6.736,6.787,6.75,6.75,0,0,0,5.656-3.008l-2.314-1.543a3.877,3.877,0,0,1-3.342,1.877,3.455,3.455,0,0,1-3.292-2.056l9.076-3.755Zm-9.256,2.263a3.724,3.724,0,0,1,3.548-3.959,2.626,2.626,0,0,1,2.52,1.44Zm-7.378,6.582h2.981V27.767h-2.981Zm-4.887-11.647h-.1a4.7,4.7,0,0,0-3.573-1.516,6.794,6.794,0,0,0,0,13.575,4.624,4.624,0,0,0,3.573-1.543h.1v.978c0,2.6-1.387,3.985-3.624,3.985a3.756,3.756,0,0,1-3.42-2.418l-2.6,1.08a6.468,6.468,0,0,0,6.017,4.011c3.5,0,6.454-2.057,6.454-7.07V34.966h-2.83Zm-3.418,9.384a4.128,4.128,0,0,1,0-8.227c2.032,0,3.624,1.749,3.624,4.14A3.792,3.792,0,0,1,109.106,45.456Zm38.91-17.687h-7.135v19.95h2.976V40.161h4.159a6.205,6.205,0,1,0,0-12.392Zm.077,9.615h-4.236V30.545h4.236a3.42,3.42,0,1,1,0,6.838Zm18.4-2.865a5.594,5.594,0,0,0-5.314,3.053l2.644,1.1a2.821,2.821,0,0,1,2.721-1.463c1.54,0,3.106.924,3.131,2.568v.2a6.587,6.587,0,0,0-3.106-.769c-2.849,0-5.75,1.566-5.75,4.491,0,2.67,2.336,4.39,4.954,4.39a4.2,4.2,0,0,0,3.8-1.952h.1v1.54h2.874V40.036C172.553,36.495,169.91,34.519,166.5,34.519Zm-.359,10.934c-.977,0-2.336-.487-2.336-1.693,0-1.54,1.693-2.131,3.157-2.131a5.313,5.313,0,0,1,2.721.667A3.61,3.61,0,0,1,166.138,45.453Zm16.888-10.5-3.414,8.65h-.1l-3.543-8.65h-3.208l5.313,12.089-3.029,6.725h3.106l8.189-18.814ZM156.2,47.719h2.978V27.768H156.2Z",
    transform: "translate(14.457 0.323)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.916 11.575)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M20.71,17.59a3.191,3.191,0,0,0-.737,2.241V55.1a3.191,3.191,0,0,0,.737,2.241l.118.115L40.583,37.7v-.466L20.828,17.475Z",
    transform: "translate(-19.973 -16.957)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M39.472,39.367l-6.585-6.588v-.466l6.588-6.586.148.085,7.8,4.432c2.228,1.267,2.228,3.339,0,4.606l-7.8,4.432Z",
    transform: "translate(-12.277 -12.039)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M47.044,36.735,40.307,30,20.435,49.874c.736.777,1.947.873,3.313.1l23.3-13.236",
    transform: "translate(-19.698 -9.493)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M47.044,30.923l-23.3-13.236c-1.366-.776-2.577-.68-3.313.1L40.307,37.657Z",
    transform: "translate(-19.698 -17.15)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidStore);
export default __webpack_public_path__ + "static/media/android_store.f9e9c0af1121b46766bb7572746b92be.svg";
export { ForwardRef as ReactComponent };